module.exports = "<div ng-switch=datepickerMode> <div uib-daypicker ng-switch-when=day tabindex=0 class=uib-daypicker template-url=app/widgets/datepicker/day.html></div> <div uib-monthpicker ng-switch-when=month tabindex=0 class=uib-monthpicker template-url=app/widgets/datepicker/month.html></div> <div uib-yearpicker ng-switch-when=year tabindex=0 class=uib-yearpicker></div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/datepicker/datepicker.html
// module id = 537
// module chunks = 0